/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tipsDailog.vue?vue&type=template&id=06606ebf&scoped=true&"
import script from "./tipsDailog.vue?vue&type=script&lang=js&"
export * from "./tipsDailog.vue?vue&type=script&lang=js&"
import style0 from "./tipsDailog.vue?vue&type=style&index=0&id=06606ebf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06606ebf",
  null
  
)

export default component.exports